import { keys, difference } from 'lodash';
import * as PIXI from 'pixi.js-legacy';
import { makeTilingSprite } from '@/play/game/util.js';
window.PIXI = PIXI;

class TilingSpriteSystem {
  constructor(systems) {
    this.systems = systems;
    this.tiledSpriteCache = {};
    this.__tileSpriteCacheLen = 0;
  }

  before(dt) {
    this.tileHitKeys = [];
  }

  after(dt) {
    const hitKeys = this.tileHitKeys;
    if (this.__tileSpriteCacheLen !== hitKeys.length) {
      const toRemove = difference(keys(this.tiledSpriteCache), hitKeys);
      const toRemoveLength = toRemove.length;
      for (let i = 0; i < toRemoveLength; i++) {
          const uuid = toRemove[i];
          const {parent,shitContainer,sprite} = this.tiledSpriteCache[uuid];
          shitContainer.removeChild(sprite);
          parent.removeChild(shitContainer);
          sprite.destroy();
          delete this.tiledSpriteCache[uuid];
          this.__tileSpriteCacheLen--;
      }
    }

  }

  update(dt, ent) {
    const uuid = ent.uuid.uuid;
    let cache = this.tiledSpriteCache[uuid];
    if (!cache) {

      let texture;
      if (ent.tiledSprite.atlas) {
        if (this.systems.gameobjects.resources[ent.tiledSprite.atlas]) {
          texture = this.systems.gameobjects.resources[ent.tiledSprite.atlas].textures[ent.tiledSprite.texture]
        }
      } else {
        if (this.systems.gameobjects.resources[ent.tiledSprite.texture]) {
          texture = this.systems.gameobjects.resources[ent.tiledSprite.texture].texture;
        }
      }

      if (!texture) {
        if (!ent.tiledSprite.atlas) {
          texture = this.systems.gameobjects.mipmappedTextures[ent.tiledSprite.texture];
        } else {
          const packedTextureName = ent.tiledSprite.texture.replace(/\//g, '_');
          texture = this.systems.gameobjects.mipmappedTextures[packedTextureName];
        }
      }
      if (!texture) {
        console.error('could not find texture');
        this.systems.addComponent(this.systems.Components.Destroy);
        return;
      }
      const {sprite,width,height} = makeTilingSprite(ent.tiledSprite, texture, ent.transform, ent.transform.anchorx, ent.transform.anchory);

      this.systems.addInnerContainer(ent.uuid.uuid, ent);
      const parent = this.systems.pixiContainers[ent.uuid.uuid].inner;

      const shitContainer = new PIXI.Container();
      shitContainer.scale.set(1/width, 1/height);
      shitContainer.addChild(sprite)

      parent.addChild(shitContainer);
      this.tiledSpriteCache[uuid] = {sprite,parent,shitContainer,width,height};
      cache = this.tiledSpriteCache[uuid]

      this.systems.createSceneGraphChildren(ent, ent.transform);

      const slots = this.systems.findSlots(ent, ent.tiledSprite);
      this.systems.addComponent(ent, slots);
    }
    const {width,height} = this.tiledSpriteCache[uuid]

    const worldPos = this.systems.getWorldPosition(ent)
    const offsetx = !isNaN(ent.tiledSprite.offsetx) ? (ent.tiledSprite.offsetx * width): 0;
    const offsety = !isNaN(ent.tiledSprite.offsety) ? (ent.tiledSprite.offsety * height): 0;
    if (ent.tiledSprite.lockToCamera) {
      let factorx = !isNaN(ent.tiledSprite.parallaxx) ? ent.tiledSprite.parallaxx : 1;
      let factory = !isNaN(ent.tiledSprite.parallaxy) ? ent.tiledSprite.parallaxy : 1;
      cache.sprite.tilePosition.set( 
        (worldPos.x*(1920/16) + offsetx) * factorx, 
        (worldPos.y*(1920/16) + offsety) * factory
      )

      //sprite.shitContainer.x = -worldPos.x/width
      //sprite.shitContainer.y = -worldPos.y/height
      //const parent = this.systems.pixiContainers[uuid].parent;
      //parent.position.set(-ent.transform.x*10, -ent.transform.y*10);

      //sprite.shitContainer.x-=2/width
      //sprite.shitContainer.y-=2/height

      // every frame, move it back by the amount it was moved
      // this only works when its top level
      cache.shitContainer.x = (-(1000/dt*2)*worldPos.x)/width;
      cache.shitContainer.y = (-(1000/dt*2)*worldPos.y)/height;

    } else {
      cache.sprite.tilePosition.set(offsetx, offsety)
    }

    //sprite.x = ent.transform.x- ent.transform.scalex * ent.transform.anchorx;
    //sprite.y = ent.transform.y- ent.transform.scaley * ent.transform.anchory;

    //sprite.x = 0
    //sprite.y = 0

    this.tileHitKeys.push(uuid);

  }
}
export default TilingSpriteSystem;
